import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Box, Button, Grid, Hidden, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { setColor2 } from "../../functions/default";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Layout from "../shared/components/LayoutComponent";
import MessageBox from "../shared/components/MessageBox";
import Page from "../shared/components/PageComponent";
function AbsenceConfirmDetails(props) {
  const { t } = useTranslation();
  let { antragid } = useParams();
  const navigate = useNavigate();
  const [antraege, setAntraege] = useState(null);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [bemerkung, setBemerkung] = useState("");
  const { showErrorMessage, hideMessage } = useMessage();
  const [sperre, setSperre] = useState(0);
  const [sperreArt, setSperreArt] = useState("");
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [wfzeZeitart, setWfzeZeitart] = useState("99");
  const [grenze, setGrenze] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "ANTRAG_HOLEN",
      absence: antragid.substring(3),
      antragVon: antragid.substring(0, 3),
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, antragCb);
    // eslint-disable-next-line
  }, []);

  const antragCb = (response) => {
    if (response.status === 200) {
      setAntraege(response.data.antraege);
      if (response.data.antraege?.wfze_za) {
        setWfzeZeitart(response.data.antraege.wfze_za);
      }
      if (response.data.gesperrt) setSperre(response.data.gesperrt);
      if (response.data.grenze) setGrenze(response.data.grenze);
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  function messageBoxResult(r) {
    const { t } = useTranslation();
    if (r === "YES") {
      setMessageBoxOpen(false);
      aufgabeaktion("GENEHMIGEN", sperreArt, true);
    }
    setMessageBoxOpen(false);
    setSperreArt("");
  }

  const aufgabeaktion = (aktion, art, nosperre) => {
    if (aktion === "GENEHMIGEN" && !nosperre) {
      if (sperre === "2") {
        setSperreArt(art);
        setMessageBoxOpen(true);
        return;
      }
      if (sperre === "1") {
        showErrorMessage(t("Antrag kann nicht genehmigt werden, da der Kontostand unter " + grenze.toString() + " fallen würde"));
        return;
      }
      if (sperre === "3") {
        showErrorMessage(t("Antrag kann nicht genehmigt werden, da der Kontostand bereits auf/unter " + grenze.toString() + " liegt"));
        return;
      }
    }
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "ANTRAG_BEARBEITEN",
      absence: antragid.substring(3),
      antragVon: antragid.substring(0, 3),
      aktion: aktion,
      bemerkung: bemerkung,
      art: art,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, aktionCB);
  };

  const aktionCB = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
      hideMessage();
      if (response.data.message === "OK") {
        navigate(-1);
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const isDisabled = (status) => {
    return status === "1" || status === "2" || status === "4";
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  if (!antraege) {
    return (
      <Typography color="primary" variant="h5">
        {t("Antrag konnte nicht gefunden werden")}
      </Typography>
    );
  }

  return (
    <Page>
      <Layout fullWidth>
      <Hidden smDown>
      <Box pt={2}>
        <Typography color="primary" variant="h5">
          {t("Antragsdetails")}
        </Typography>
        </Box>
      </Hidden>
      <Box p={2}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
              {antraege.vg && antraege.vg !== "" && (
                <Grid item xs={12}>
                  <Typography align="center" fullWidth style={{ color: setColor2("255100100", 1) }}>
                    {"Stellvertretend für " + antraege.vg}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Antragsteller")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.von}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Art des Antrags")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.typ}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Beantragt am")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.gestellt}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Zeitraum")}
                  multiline
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.zeitraum}
                ></TextField>
              </Grid>
              {antraege.hinwan !== "" && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Bemerkung (Antragsteller)")}
                    multiline
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled={isDisabled(antraege.status)}
                    value={antraege.hinwan}
                  ></TextField>
                </Grid>
              )}
              {antraege.hinwvg !== "" && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Bemerkung (Vorgesetzter)")}
                    multiline
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled={isDisabled(antraege.status)}
                    value={antraege.hinwvg}
                  ></TextField>
                </Grid>
              )}
              {antraege.stornobem !== "" && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Bemerkung zur Stornierung (Antragsteller)")}
                    multiline
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.stornobem}
                  ></TextField>
                </Grid>
              )}
              {antraege.vzeit && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Von Zeit")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.vzeit}
                  ></TextField>
                </Grid>
              )}
              {antraege.bzeit && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Bis Zeit")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.bzeit}
                  ></TextField>
                </Grid>
              )}
              {antraege.fzeit && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Fahrtzeit")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.fzeit}
                  ></TextField>
                </Grid>
              )}
              {antraege.vertreter_name && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Vertreter")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.vertreter_name}
                  ></TextField>
                </Grid>
              )}
              {antraege.proz && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Auszahlungsprozent")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.proz}
                  ></TextField>
                </Grid>
              )}
              {antraege.reisegrund && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Reisegrund")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.reisegrund}
                  ></TextField>
                </Grid>
              )}
              {antraege.reiseland && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Reiseland")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.reiseland}
                  ></TextField>
                </Grid>
              )}
              {antraege.reiseort && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Reiseort")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.reiseort}
                  ></TextField>
                </Grid>
              )}
              {antraege.reisevkm && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Reise Verkehrsmittel")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.reisevkm}
                  ></TextField>
                </Grid>
              )}

              {antraege.zeiten && antraege.zeiten.length > 0 && (
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableCell>{t("Zeit Buchung")}</TableCell>
                        {wfzeZeitart === "00" && <TableCell>{t("Zeitart")}</TableCell>}
                      </TableHead>
                      <TableBody>
                        {antraege.zeiten.map((item, index) => (
                          <>
                            <TableRow>
                              <TableCell>{item.datum + "    " + item.vzeit + " - " + item.bzeit}</TableCell>
                              {wfzeZeitart === "00" && <TableCell>{item.za_bez}</TableCell>}
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}

              {antraege.zahlart && antraege.zahlart !== "00" && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    label={t("Vergütungsart")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    disabled
                    value={antraege.zahlart}
                  ></TextField>
                </Grid>
              )}
              {antraege.salden && antraege.salden.length > 0 && !isDisabled(antraege.status) && (
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t("Konto")}</TableCell>
                          <TableCell align="right">{t("Heute")}</TableCell>
                          <TableCell align="right">{t("Geplant bis 31.12.")}</TableCell>
                          <TableCell align="right">{t("Aktueller Antrag")}</TableCell>
                          <TableCell align="right">{t("Endstand zum 31.12.")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {antraege.salden.map((row, count) => {
                          var background = "";
                          if (row.wert_n < 0) {
                            background = "rgb(244, 067, 054, 0.8)";
                          }
                          return (
                            <TableRow key={count} style={{ backgroundColor: background }}>
                              <TableCell component="th" scope="row">
                                {row.bez}
                              </TableCell>
                              <TableCell align="right">{row.wert_h}</TableCell>
                              <TableCell align="right">{row.wert_p}</TableCell>
                              <TableCell align="right">{row.wert_a}</TableCell>
                              <TableCell align="right">{row.wert_n}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("eigene Abwesenheit")}
                  error={antraege.eigene}
                  helperText={antraege.eigene && "Überschneidung"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.eigene ? antraege.eigene : "-"}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={t("Antragsteller vertritt")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  value={antraege.vertritt ? antraege.vertritt : "-"}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <Button fullWidth color="primary" startIcon={<CalendarTodayIcon />} onClick={() => navigate("/PMABWU")}>
                  {t("Wechsel zu Abwesenheitsübersicht")}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  id="eigeneBemerkung"
                  label={t("Eigene Bemerkung")}
                  defaultValue={bemerkung}
                  disabled={isDisabled(antraege.status)}
                  onChange={(event) => setBemerkung(event.target.value)}
                />
              </Grid>
              {(!antraege.am || antraege.am !== "M") && (
                <Fragment>
                  <Grid item xs={12} sm={6} order={{ xs: 2, sm: 1 }}>
                    <Button fullWidth variant="outlined" disabled={isDisabled(antraege.status)} onClick={() => aufgabeaktion("ABLEHNEN", antraege.art)}>
                      {t("ablehnen")}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} order={{ xs: 1, sm: 2 }}>
                    <Button
                      fullWidth
                      variant="contained"
                      disabled={isDisabled(antraege.status)}
                      color="primary"
                      onClick={() => aufgabeaktion("GENEHMIGEN", antraege.art)}
                    >
                      {t("genehmigen")}
                    </Button>
                  </Grid>
                </Fragment>
              )}
              {antraege.am && antraege.am === "M" && (
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    disabled={isDisabled(antraege.status)}
                    color="primary"
                    onClick={() => aufgabeaktion("KENNTNIS", antraege.art)}
                  >
                    {t("zur Kenntnis nehmen")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <MessageBox
        title={t("Hinweis")}
        text={t("Kontostand fällt mit dem Genehmigen unter " + grenze.toString() + ", trotzdem genehmigen?")}
        buttons="YESNO"
        onClose={() => setMessageBoxOpen(false)}
        open={messageBoxOpen}
        handleResponse={(r) => messageBoxResult(r)}
      />
      </Layout>
    </Page>
  );
}
export default AbsenceConfirmDetails;
